// @ts-nocheck
import React, { createContext, useContext, ReactNode } from 'react';
import { useOrganization } from '@/hooks/useOrganization';

interface Organization {
  id: string;
  name: string;
  slug: string;
  logo_url: string | null;
  primary_color: string;
  secondary_color: string;
  access_tier: 'full_access' | 'export_only';
  status: 'active' | 'trial' | 'inactive';
}

interface OrganizationContextType {
  organization: Organization;
  isLoading: boolean;
  error: Error | null;
}

const OrganizationContext = createContext<OrganizationContextType | undefined>(undefined);

export const OrganizationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { organization, isLoading, error } = useOrganization();

  const value = React.useMemo(
    () => ({ organization, isLoading, error }),
    [organization, isLoading, error]
  );

  return (
    <OrganizationContext.Provider value={value}>
      {children}
    </OrganizationContext.Provider>
  );
};

export const useOrganizationContext = () => {
  const context = useContext(OrganizationContext);
  if (context === undefined) {
    throw new Error('useOrganizationContext must be used within an OrganizationProvider');
  }
  return context;
};
